export default __webpack_public_path__ + "static/media/uel.8f217bbe.png";